import { render, staticRenderFns } from "./resource-personalization.vue?vue&type=template&id=4b751035&"
import script from "./resource-personalization.vue?vue&type=script&lang=ts&"
export * from "./resource-personalization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports